import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { styled, css } from 'styled-components';
import { COLLAPSING_TRANSITION, ITEMS_LIST_PADDING } from '../constants.js';
import { usePuzzleNavigationContext } from '../context.js';
const Separator = styled.div `
  height: 1px;
  background-color: ${({ theme }) => theme.colors.grey10_1};
  transition: ${COLLAPSING_TRANSITION};

  ${({ $standalone, $isCollapsedNav }) => $standalone
    ? css `
          margin: 0 auto;
          width: ${$isCollapsedNav ? `calc(100% - (${ITEMS_LIST_PADDING} * 2))` : '100%'};
        `
    : css `
          margin: 8px auto;
          width: ${$isCollapsedNav ? '100%' : `calc(100% + (${ITEMS_LIST_PADDING} * 2))`};
          transform: ${$isCollapsedNav ? 'translateX(0)' : `translateX(-${ITEMS_LIST_PADDING})`};
          &:first-child {
            display: none;
          }
        `}
`;
export const ItemSeparator = memo(function ItemSeparator({ standalone }) {
    const { isCollapsedNav } = usePuzzleNavigationContext();
    return _jsx(Separator, { $isCollapsedNav: isCollapsedNav, $standalone: standalone });
});
